import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { salesQuoteService } from '../../../services/salesQuoteService';
import VentasCommercialForm from '../../../components/Ventas/VentasCommercialForm';
import Toast from '../../../components/Common/Toast';

const EditVentasQuote = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [quote, setQuote] = useState(null);
  const [loading, setLoading] = useState(true);
  const [toast, setToast] = useState({ isOpen: false, message: '', type: 'info' });

  useEffect(() => {
    const load = async () => {
      try {
        const res = await salesQuoteService.getQuote(id);
        if (res.success) setQuote(res.data);
        else navigate('/ventas/quotes', { state: { posConfirmed: true } });
      } catch {
        navigate('/ventas/quotes', { state: { posConfirmed: true } });
      } finally {
        setLoading(false);
      }
    };
    if (id) load();
  }, [id, navigate]);

  if (loading) {
    return <div className="p-6 text-center text-gray-500">Cargando...</div>;
  }

  const readOnly = quote?.status === 'cancelled';

  return (
    <div className="p-6">
      <div className="max-w-5xl mx-auto">
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-gray-800">
            {readOnly ? 'Ver cotización' : 'Editar cotización'}
          </h1>
          <p className="text-sm font-mono text-teal-600 mt-1">{quote?.code}</p>
        </div>
        <VentasCommercialForm
          mode="quote"
          entity={quote}
          readOnly={readOnly}
          isPageMode
          onClose={() => navigate('/ventas/quotes', { state: { posConfirmed: true } })}
          onSuccess={() => navigate('/ventas/quotes', { state: { posConfirmed: true } })}
        />
        <Toast
          isOpen={toast.isOpen}
          message={toast.message}
          type={toast.type}
          onClose={() => setToast({ ...toast, isOpen: false })}
        />
      </div>
    </div>
  );
};

export default EditVentasQuote;
